import type { PointHubSDK, PointHubScenarioEventConfig } from '@ripple/point-hub-web-sdk';

interface PointHubRuntimeCache {
  clientKey: string | null;
  client: PointHubSDK | null;
  initPromise: Promise<PointHubScenarioEventConfig | null> | null;
  identityKey: string | null;
  reports: Map<string, { state: 'reporting' | 'finished'; updatedAt: number }>;
}

const CACHE_KEY = '__webTeamsPointHubRuntimeCache__';

const createCache = (): PointHubRuntimeCache => ({
  clientKey: null,
  client: null,
  initPromise: null,
  identityKey: null,
  reports: new Map()
});

const getGlobalCacheHost = (): Record<string, unknown> => {
  return globalThis as unknown as Record<string, unknown>;
};

export const getPointHubRuntimeCache = (): PointHubRuntimeCache => {
  const host = getGlobalCacheHost();
  if (!host[CACHE_KEY]) host[CACHE_KEY] = createCache();
  return host[CACHE_KEY] as PointHubRuntimeCache;
};

export const resetPointHubRuntimeCacheForTest = (): void => {
  delete getGlobalCacheHost()[CACHE_KEY];
};
